import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formValueSelector, change } from 'redux-form';
import { Icon, Dimmer, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as fileActions from '../store/file/fileActions';

const SIZE_LIMIT = 100 * 1024 * 1024;

class Video extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    uploadFile: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    videoName: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    setFileName: PropTypes.func.isRequired,
  };
  /**
   * Default constructor to set up state and functions
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      error: false,
    };
    this.validExt = ['mpg', 'mpeg', 'avi', 'mp4', 'wmv', 'mov', '3gp', 'mkv'];
  }

  onUploadImage = () => {
    this.fileInput.click();
  };

  handleSelectFile = files => {
    this.setState({ error: false });
    if (files && files.length > 0) {
      const file = files[0];
      const fileExt = file.name.match(/\.([^\.]+)$/)[1];
    //  if (this.validExt.includes(fileExt)) {
        if (file && file.size) {
          if (file.size < SIZE_LIMIT) {
            this.props.setFileName(
              this.props.meta.form,
              'videoName',
              file.name
            );
            this.props.uploadFile(
              file,
              this.props.season.sfId,
              this.props.meta.form,
              this.props.input.name
            );
          } else {
            this.setState({ error: true });
          }
        }
      /*} else {
        this.setState({ error: true });
      }*/

    }
  };

  handleRemoveFile = () => {
    this.props.removeFile(this.props.meta.form, this.props.input.name);
    this.props.setFileName(this.props.meta.form, 'videoName', null);
  };

  renderRequire = () => (
    <span className="tiny-message error">
      <i>Required.</i>
    </span>
  );

  renderWarning = () => {
    if (this.state.error) {
      return (
        <p className="warning">
          The file you attempted to upload is either not the correct file type
          or is too large.
        </p>
      );
    }
    return '';
  };

  renderFileName = () => {
    if (this.props.videoName) {
      return (
        <div className="fileUploadContainerList hasFileUpload">
          <p className="fileUploadName">{this.props.videoName}</p>
          <button
            className="ui circular primary icon button"
            onClick={this.handleRemoveFile}
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <Icon className="times" />
          </button>
        </div>
      );
    }
  };

  render() {
    const {
      season,
      meta: { touched, invalid },
    } = this.props;
    const fileName = this.renderFileName();
    const error = this.renderWarning();
    return (
      <div>
        <h4
          className="ui dividing header"
          style={{ color: `#${season.hexColorCodeC}` }}
        >
          Submit Your Video
        </h4>
        {this.props.loading && (
          <Dimmer active inverted>
            <Loader size="large">Loading</Loader>
          </Dimmer>
        )}

        <p>
          Please ensure your video is less than 50MB and in one of the following
          file formats : mpg, mpeg, avi, mp4, wmv, mov, 3gp, mkv
        </p>

        {fileName}
        {error}
        <div className="field" onClick={this.onUploadImage}>
          <label
            style={{ backgroundColor: `#${season.hexColorCodeC}` }}
            htmlFor="fileUpload"
            className="ui fluid huge primary right labeled icon button"
          >
            <Icon className="ui cloud upload icon" />
            Upload video
          </label>
        </div>
        {touched && invalid && this.renderRequire()}
        <input
          type="file"
          accept="video/mpg,video/mpeg,video/avi,video/mp4,video/wmv,video/mov,video/3gpp,video/mkv,video/*"
          ref={input => {
            this.fileInput = input;
          }}
          className="inputFile"
          onChange={e => this.handleSelectFile(e.target.files)}
        />
      </div>
    );
  }
}

const mapStatesToProps = (state, props) => ({
  videoName: formValueSelector(props.meta.form)(state, 'videoName'),
  loading: state.file.loading,
});

const mapDispatchToProps = dispatch => ({
  uploadFile: (file, seasonId, form, name) =>
    dispatch(fileActions.uploadFile(file, seasonId, form, name, 'video')),
  removeFile: (formName, fieldName) =>
    dispatch(change(formName, fieldName, null)),
  setFileName: (formName, fieldName, value) =>
    dispatch(change(formName, fieldName, value)),
});

export default connect(mapStatesToProps, mapDispatchToProps)(Video);



// WEBPACK FOOTER //
// ./src/components/Video.js